import { render } from "./ApplicantTabWork.vue?vue&type=template&id=a8bf4656"
import script from "./ApplicantTabWork.vue?vue&type=script&lang=js"
export * from "./ApplicantTabWork.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__